import { render, staticRenderFns } from "./u-btn-text-fit.vue?vue&type=template&id=fa0fe108&scoped=true"
import script from "./u-btn-text-fit.vue?vue&type=script&lang=js"
export * from "./u-btn-text-fit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0fe108",
  null
  
)

export default component.exports